import { ColDef } from 'ag-grid-community';

/**
 * Wallet type filter options for the wallet balance report
 */
export const WALLET_REPORT_TYPE_OPTIONS = [
  { label: 'Merchant', value: 'MERCHANT' },
  { label: 'Customer', value: 'CUSTOMER' }
];

/**
 * Column definitions for the wallet balance report grid
 */
export const WALLET_REPORT_COLUMN_DEFS: ColDef[] = [
  { field: 'date', sortable: false, lockVisible: true, headerName: 'Date', valueGetter: (params) => params.data?.date || 'N/A' },
  { field: 'walletType', sortable: false, lockVisible: true, headerName: 'Wallet Type', valueGetter: (params) => params.data?.walletType || 'N/A' },
  { field: 'mobileNumber', sortable: false, lockVisible: true, headerName: 'Mobile Number', valueGetter: (params) => params.data?.mobileNumber || 'N/A' },
  {
    field: 'balance', sortable: false, lockVisible: true, headerName: 'Balance',
    valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : 'N/A'
  }
];
